import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchApprovalTypes = createAsyncThunk("fetchApprovalTypes", async () => {
	try {
		const response = await axiosHttp.get(`approvals/types`);
		return response.data.data;
	} catch (error) {
		console.error("API Error:", error);
		throw error;
	}
});

const ApprovalTypesSlice = createSlice({
	name: "ApprovalTypesSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchApprovalTypes.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchApprovalTypes.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchApprovalTypes.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default ApprovalTypesSlice.reducer;
